import {Injectable} from '@angular/core';
import {Country} from '../../common/components/navigation-bar/registration-dialog/types/country.types';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  /**
   * function for transforming country code from database to Country
   * @param countryCode for evaluating correct Country
   */
  transformCountryCodeCountry(countryCode: string): Country {
    switch (countryCode) {
      case 'CZ': return Country.CZ;
      case 'SK': return Country.SK;
      case 'Poland': return Country.PL;
      case 'Hungary': return Country.HU;
      case 'Romania': return Country.RO;
      default: return Country.SK;
    }
  }

  /**
   * function for transforming Country to database country code
   * @param country for evaluating correct Country and transforming into country code
   */
  transformCountryToCountryCode(country: string): string {
    switch (country) {
      case Country.CZ: return 'CZ';
      case Country.SK: return 'SK';
      case Country.PL: return 'PL';
      case Country.HU: return 'HU';
      case Country.RO: return 'RO';
      default: return 'SK';
    }
  }
}
